<template>
  <div>
    <div class="columns has-background-light is-border-bottom is-border--dashed is-gapless is-marginless">
      <div class="column is-padding-small">
        <router-link :to="{name: 'StatsSales'}">
          <span class="has-text-grey has-text-weight-normal is-size-6">
            <span class="has-text-weight-normal">Période de</span>
            <span class="has-text-grey has-text-weight-normal is-dotted">
              {{ startDate.format('MMMM YYYY') | uppercase }}
            </span>
            <span class="has-text-weight-normal">à</span>
            <span class="has-text-grey has-text-weight-normal is-dotted">
              {{ endDate.format('MMMM YYYY') | uppercase }}
            </span>
          </span>
        </router-link>
      </div>
    </div>
    <div class="columns is-vcentered is-border-bottom is-border-dashed is-gapless">
      <div class="column is-padding-small">
        <p class="is-padding-bottom-small has-text-grey is-size-6">
          {{ users.length }} Membre(s) dans la structure
        </p>
        <div class="field is-grouped is-grouped-multiline">
          <span
            class="control is-inline-flex tooltip is-tooltip-bottom"
            v-for="(u, i) in users.slice(0, 6)"
            :key="u.pk"
            :data-tooltip="`${u.last_name} ${u.first_name}`">
            <router-link :to="{name: 'UserVue', params: {id: u.pk}}">
              <avatar
                :item="u"
                :i="i"></avatar>
            </router-link>
          </span>
          <router-link
            :to="{name: 'UserList'}"
            class="control is-self-centered is-inline-flex"
            v-if="users.length > 6">
            <span
              class="avatar"
              :class="'avatar-01'">
              <span>{{ users.length - 6 }}+</span>
            </span>
          </router-link>
        </div>
      </div>
    </div>
    <div class="column has-text-grey is-size-6 is-padding-small">
      <p>
        CA prix immo <span class="has-text-weight-normal">sur la période du</span>
        <span class="has-text-grey has-text-weight-normal"> {{ startDate.format('DD MMMM YYYY') }} </span>
        <span class="has-text-weight-normal">au</span>
        <span class="has-text-grey has-text-weight-normal"> {{ endDate.format('DD MMMM YYYY') }} </span>
      </p>
      <span class="has-text-draft has-text-weight-bold"><em>(Réservations + ventes actées)</em></span>
    </div>
    <div class="column is-border-bottom is-border--dashed is-padding-left is-padding-bottom is-padding-right">
      <span class="is-size-1 has-text-weight-medium is-inline-block">{{ totalCA | prettyPrice }} €</span>
      <sup
        v-if="evoTotalCA"
        class="is-size-5">
        <i
          class="fal fa-arrow-right is-inline-block is-top is-margin-top-xsmall"
          :class="evoTotalCA > 0 ? 'is-rotate-315 has-text-success' : 'is-rotate-45 has-text-danger'"></i>
      </sup>
      <br><span
        class="is-size-7"
        v-if="evoTotalCA"
        :class="evoTotalCA > 0 ? 'has-text-success' : 'has-text-danger'">
        <span v-if="evoTotalCA && evoTotalCA > 0">+ </span>{{ evoTotalCA }} %
        <span class="has-text-draft">par rapport à la période du {{ previousStartDate }} au {{ previousEndDate }}</span>
      </span>
    </div>
    <div class="column columns is-paddingless-bottom is-marginless-bottom">
      <div
        class="column is-border-bottom is-border-right is-border--dashed graph-over graph-over--decoration"
        :class="[!canUseCalendar ? 'is-6' : 'is-4 ']"
        @click="goToRoute('AdvList', {status: 'reserved'})">
        <div class="column is-size-6 has-text-grey is-paddingless-bottom">
          Résa en cours
        </div>
        <div class="column">
          <span class="is-size-4 has-text-weight-bold">{{ pendingResa }}</span>
          <sup
            v-if="evoPendingResa"
            class="is-size-5">
            <i
              class="fal fa-arrow-right is-inline-block is-top is-margin-top-xsmall"
              :class="evoPendingResa > 0 ? 'is-rotate-315 has-text-success' : 'is-rotate-45 has-text-danger'"></i>
          </sup>
          <br>
          <span
            class="is-size-7"
            v-if="evoPendingResa"
            :class="evoPendingResa > 0 ? 'has-text-success' : 'has-text-danger'">
            <span v-if="evoPendingResa && evoPendingResa > 0">+ </span>{{ evoPendingResa }} %
          </span>
        </div>
      </div>
      <div
        class="column is-border-bottom is-border--dashed graph-over graph-over--decoration"
        :class="[!canUseCalendar ? 'is-6' : 'is-4 is-border-right']"
        @click="goToRoute('AdvList', {status: 'canceled'})">
        <div class="column is-size-6 has-text-grey is-paddingless-bottom">
          Résa annulées
        </div>
        <div class="column">
          <span class="is-size-4 has-text-weight-bold">{{ canceledResa }}</span>
          <sup
            v-if="evoCanceledResa"
            class="is-size-5">
            <i
              class="fal fa-arrow-right is-inline-block is-top is-margin-top-xsmall"
              :class="evoCanceledResa > 0 ? 'is-rotate-45 has-text-danger' : 'is-rotate-315 has-text-success'"></i>
          </sup>
          <br>
          <span
            class="is-size-7"
            v-if="evoCanceledResa"
            :class="evoCanceledResa > 0 ? 'has-text-danger' : 'has-text-succes'">
            <span v-if="evoCanceledResa && evoCanceledResa > 0">+ </span>{{ evoCanceledResa }} %
          </span>
        </div>
      </div>
      <div
        v-if="canUseCalendar"
        @click="goToRoute('CalendarList', {}, { year: moment().format('YYYY'), month: moment().format('MM'), day: moment().format('DD'), panel: 'rdvs' })"
        class="column is-4 is-border-bottom is-border--dashed has-background-light graph-over graph-over--decoration">
        <div class="column is-size-6 has-text-grey is-paddingless-bottom">
          Rendez-vous à venir ({{ startDate.format('YYYY') }})
        </div>
        <div class="column">
          <span class="is-size-4 has-text-weight-bold">{{ futureRdvsCount }}</span>
        </div>
      </div>
    </div>
    <div class="column columns is-paddingless is-gapless is-marginless">
      <div
        class="column is-6 is-padding-xxsmall is-border-bottom is-border-right is-border--dashed graph-over graph-over--decoration"
        @click="goToRoute('AdvList', {status: 'sold'})">
        <div class="column is-size-6 has-text-grey is-paddingless-bottom">
          Ventes actées
        </div>
        <div class="column">
          <span class="is-size-4 has-text-weight-bold">{{ soldCount }}</span>
          <sup
            v-if="evoSoldCount"
            class="is-size-5">
            <i
              class="fal fa-arrow-right is-inline-block is-top is-margin-top-xsmall"
              :class="evoSoldCount > 0 ? 'is-rotate-315 has-text-success' : 'is-rotate-45 has-text-danger'"></i>
          </sup>
          <br>
          <span
            class="is-size-7"
            v-if="evoSoldCount"
            :class="evoSoldCount > 0 ? 'has-text-success' : 'has-text-danger'">
            <span v-if="evoSoldCount && evoSoldCount > 0">+ </span>{{ evoSoldCount }} %
          </span>
        </div>
      </div>
      <div
        class="column is-6 is-padding-xxsmall is-border-bottom is-border--dashed graph-over graph-over--decoration"
        @click="goToRoute('StatsSales')">
        <div class="column is-size-6 has-text-grey is-paddingless-bottom">
          Prix de vente moyen
        </div>
        <div class="column">
          <span
            class="is-size-4 has-text-weight-bold"
            v-if="moyCA">{{ moyCA | prettyPrice }} €</span>
          <span
            class="is-size-4 has-text-weight-bold"
            v-else>0</span>
          <sup
            v-if="evoMoyCA"
            class="is-size-5">
            <i
              class="fal fa-arrow-right is-inline-block is-top is-margin-top-xsmall"
              :class="evoMoyCA > 0 ? 'is-rotate-315 has-text-success' : 'is-rotate-45 has-text-danger'"></i>
          </sup>
          <br>
          <span
            class="is-size-7"
            v-if="evoMoyCA"
            :class="evoMoyCA > 0 ? 'has-text-success' : 'has-text-danger'">
            <span v-if="evoMoyCA && evoMoyCA > 0">+ </span>{{ evoMoyCA }} %
          </span>
        </div>
      </div>
    </div>
    <div class="column columns is-marginless-bottom is-paddingless-bottom">
      <div
        class="column is-6 is-border-bottom is-border-right is-border--dashed"
        v-if="bestSeller && checkEmpty(bestSeller)"
        @click="goToRoute('UserVue', null, {id: bestSeller.id})">
        <div class="column is-size-6 has-text-grey is-paddingless-bottom">
          Plus forte activité
        </div>
        <div class="column is-padding-top-xsmall">
          <span class="is-size-4 has-text-weight-bold">{{ bestSeller.name }}</span>
          <br>
          <span class="is-size-7 has-text-weight-light">
            {{ bestSeller.saleCount }} vente(s) actée(s)
            <br>{{ bestSeller.resaCount }} réservation(s) en cours
            <br v-if="canUseCalendar">
            <span v-if="canUseCalendar">{{ bestSeller.rdvCount }} RDV à venir</span>
          </span>
        </div>
      </div>
      <div
        class="column is-6 is-border-bottom is-border--dashed"
        v-if="bestCompany && checkEmpty(bestCompany)">
        <div class="column is-size-6 has-text-grey is-paddingless-bottom">
          Société la plus active
        </div>
        <div class="column is-padding-top-xsmall">
          <span class="is-size-4 has-text-weight-bold">
            {{ bestCompany.name }}
          </span>
          <br>
          <span class="is-size-7 has-text-weight-light">
            {{ bestCompany.saleCount }} vente(s) actée(s)
            <br>{{ bestCompany.resaCount }} réservation(s) en cours
          </span>
        </div>
      </div>
    </div>
    <div class="column is-padding-xsmall">
      <router-link
        :to="{name: 'StatsSales'}"
        class="button is-white is-size-7 is-paddingless-right">
        <span class="icon is-small">
          <i class="fal fa-chart-bar"></i>
        </span>
        <span class="is-padding-right-small">Toutes les statistiques</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { isEmpty, last, sortBy, groupBy } from 'lodash'
import { mapGetters } from 'vuex'

export default {
  name: 'DashboardStatsActivity',
  props: {
    statsSales: {
      type: Array,
      default: () => []
    },
    statsSalesReference: {
      type: Array,
      default: () => []
    },
    users: {
      type: Array,
      default: () => []
    },
    futureRdvs: {
      type: Array,
      default: () => []
    },
    futureRdvsCount: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      startDate: moment().startOf('year'),
      endDate: moment().endOf('day'),
      moment
    }
  },
  computed: {
    ...mapGetters(['canUseCalendar', 'accountPk']),
    sales () {
      return this.statsSales
    },
    previousSales () {
      return this.statsSalesReference
    },
    pendingResa () {
      return this.sales.filter(x => x.status === 'reserved').length
    },
    evoPendingResa () {
      if (!isEmpty(this.sales) && !isEmpty(this.previousSales)) {
        let previousPendings = this.previousSales.filter(x => x.status === 'reserved').length
        return ((previousPendings / this.pendingResa) * 100).toFixed(2)
      } else return null
    },
    canceledResa () {
      return this.sales.filter(x => x.status === 'canceled').length
    },
    evoCanceledResa () {
      if (!isEmpty(this.sales) && !isEmpty(this.previousSales)) {
        let previousCancels = this.previousSales.filter(x => x.status === 'canceled').length
        return ((previousCancels / this.canceledResa) * 100).toFixed(2)
      } else return null
    },
    soldCount () {
      return this.sales.filter(x => x.status === 'sold').length
    },
    evoSoldCount () {
      if (!isEmpty(this.sales) && !isEmpty(this.previousSales)) {
        let previousSold = this.previousSales.filter(x => x.status === 'sold').length
        return ((previousSold / this.soldCount) * 100).toFixed(2)
      } else return null
    },
    totalCA () {
      return this.sales.filter(x => ['sold', 'reserved'].includes(x.status)).reduce((a, b) => {
        return a + b.sale_price_ttc
      }, 0)
    },
    totalYearCA () {
      return this.yearSales.filter(x => ['sold', 'reserved'].includes(x.status)).reduce((a, b) => {
        return a + b.sale_price_ttc
      }, 0)
    },
    evoTotalCA () {
      if (!isEmpty(this.sales) && !isEmpty(this.previousSales)) {
        let previousCA = this.previousSales.filter(x => ['sold', 'reserved'].includes(x.status)).reduce((a, b) => {
          return a + b.sale_price_ttc
        }, 0)
        return ((previousCA / this.totalCA) * 100).toFixed(2)
      } else return null
    },
    moyCA () {
      let sold = this.sales.filter(x => ['sold', 'reserved'].includes(x.status))
      if (!sold.length) return
      return this.totalCA / sold.length
    },
    evoMoyCA () {
      if (!isEmpty(this.sales) && !isEmpty(this.previousSales)) {
        let currentMoy = this.sales.filter(x => ['sold', 'reserved'].includes(x.status))
        let currentMoyVal = currentMoy.reduce((a, b) => {
          return a + b.sale_price_ttc
        }, 0) / currentMoy.length
        let previousMoy = this.previousSales.filter(x => ['sold', 'reserved'].includes(x.status))
        let previousMoyVal = previousMoy.reduce((a, b) => {
          return a + b.sale_price_ttc
        }, 0) / previousMoy.length
        return ((currentMoyVal - previousMoyVal) / previousMoyVal * 100).toFixed(2)
      } else return null
    },
    previousStartDate () {
      let startDate = this.startDate.clone().startOf('month')
      let endDate = this.endDate.clone().endOf('month')
      let delta = endDate.diff(startDate, 'days')
      return startDate.clone().subtract(delta, 'days').format('DD MMMM YYYY')
    },
    previousEndDate () {
      let startDate = this.startDate.clone().startOf('month')
      let endDate = this.endDate.clone().endOf('month')
      let delta = endDate.diff(startDate, 'days')
      return endDate.clone().subtract(delta, 'days').format('DD MMMM YYYY')
    },
    bestSeller () {
      let sales = this.sales.filter(x => x.status === 'sold')
      let resa = this.sales.filter(x => x.status === 'reserved')
      let groupSale = groupBy(sales, x => x.user.pk)
      let groupResa = groupBy(resa, x => x.user.pk)
      let groupRdv = groupBy(this.futureRdvs, x => x.user.pk)
      let users = this.users.map(x => {
        return {
          id: x.pk,
          name: `${x.first_name} ${x.last_name}`,
          saleCount: groupSale[x.pk] ? groupSale[x.pk].length : 0,
          rdvCount: groupRdv[x.pk] ? groupRdv[x.pk].length : 0,
          resaCount: groupResa[x.pk] ? groupResa[x.pk].length : 0
        }
      })
      let lastSeller = last(sortBy(users, x => {
        return x.saleCount + x.rdvCount + x.resaCount
      }))
      if (lastSeller && lastSeller.saleCount + lastSeller.resaCount > 0) {
        return lastSeller
      } else return null
    },
    bestCompany () {
      let sales = this.sales.filter(x => x.status === 'sold' && x.account.pk !== this.accountPk)
      let resa = this.sales.filter(x => x.status === 'reserved' && x.account.pk !== this.accountPk)
      let allSales = this.sales.filter(x => ['reserved', 'sold'].includes(x.status) && x.account.pk !== this.accountPk)
      let groupSale = groupBy(sales, x => x.user.pk)
      let groupResa = groupBy(resa, x => x.user.pk)
      let groupCompany = groupBy(allSales, x => x.account.pk)
      groupCompany = Object.values(groupCompany).map(y => {
        return y.map(x => {
          return {
            id: x.pk,
            name: x.account.name,
            companyId: x.account.pk,
            saleCount: groupSale[x.user.pk] ? 1 : 0,
            resaCount: groupResa[x.user.pk] ? 1 : 0
          }
        }).reduce((a, b) => {
          return {
            name: b.name,
            id: b.id,
            saleCount: a.saleCount + b.saleCount,
            resaCount: a.resaCount + b.resaCount
          }
        }, { saleCount: 0, resaCount: 0 })
      })
      let lastCompany = last(sortBy(groupCompany, x => {
        return x.saleCount + x.resaCount
      }))
      if (lastCompany && lastCompany.saleCount + lastCompany.resaCount > 0) {
        return lastCompany
      } else return null
    }
  },
  methods: {
    checkEmpty (v) {
      return !isEmpty(v)
    },
    goToRoute (route, query, params) {
      if (route === 'AdvList' && query) {
        if (query.status === 'sold') {
          Object.assign(query, {
            sale_date__gte: this.startDate.toISOString(),
            sale_date__lte: moment().toISOString()
          })
        } else {
          Object.assign(query, {
            signature_date__gte: this.startDate.toISOString(),
            signature_date__lte: moment().toISOString()
          })
        }
      }
      this.$router.push({ name: route, query, params })
    }
  }
}
</script>
